export default __webpack_public_path__ + "static/media/Add_Note.c05fa8c7.svg";